let WebRtcPeer = require('./kurento-dev');

exports.WebRtcPeer = WebRtcPeer;
